import apiClient from '@/services/axios'

export async function get(userId, params = {}) {
  var response = await apiClient.get('/users/' + userId + '/eventlog', { params })
  if (response) {
    return response.data
  }

  throw new Error('Unable to get User event log.')
}
